import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { DashboardButton } from "@/dashboard-design-system/DashboardButton";
import {
  DashboardDialog,
  DashboardDialogBody,
  DashboardDialogContent,
  DashboardDialogFooter,
  DashboardDialogHeader,
} from "@/dashboard-design-system/DashboardDialog";
import { DashboardTypography } from "@/dashboard-design-system/Typography";
import { Delete } from "@/icons/outlined";

interface DeleteTaxDialogProps {
  taxName: string;
  isDeleting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteTaxDialog: FC<DeleteTaxDialogProps> = ({ taxName, isDeleting, onConfirm, onCancel }) => {
  const { t } = useTranslate();

  return (
    <DashboardDialog open onClose={onCancel} vibe="danger" maxWidth="xs">
      <DashboardDialogBody
        slots={{
          header: (
            <DashboardDialogHeader
              icon={<Delete />}
              title={t("dashboard", "taxes.manage.deleteTitle", { name: taxName })}
            />
          ),
          content: (
            <DashboardDialogContent>
              <DashboardTypography variant="body2" vibe="text-neutral-moderate">
                {t("dashboard", "taxes.manage.deleteDescription")}
              </DashboardTypography>
            </DashboardDialogContent>
          ),
          footer: (
            <DashboardDialogFooter>
              <DashboardButton
                vibe="danger"
                isLoading={isDeleting}
                onClick={onConfirm}
                type="button"
                data-test="delete-tax-confirm"
              >
                {t("dashboard", "taxes.manage.deleteConfirm")}
              </DashboardButton>
              <DashboardButton vibe="neutral" variant="outlined" onClick={onCancel} data-test="delete-tax-cancel">
                {t("dashboard", "taxes.manage.cancel")}
              </DashboardButton>
            </DashboardDialogFooter>
          ),
        }}
      />
    </DashboardDialog>
  );
};
